import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Ticker } from '@pixi/ticker';

import { Shared } from '../App';
import LocalisedText from './LocalisedText';

export class VideoIcon extends Container
{
    private _animate: boolean;
    private icon: Sprite;

    constructor(animate = true)
    {
        super();

        this._animate = animate;
        this.icon = Sprite.from(Shared.assets.getTexture('video-ad'));
        this.icon.anchor.set(0.5);
        this.addChild(this.icon);
        
        var adIconTitle = new LocalisedText('adIcon_title_short', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 3 * 2,
            lineJoin: 'round',
            align: 'center',
            fontSize: 16 * 2,
            maxWidth: 160,
            scale: 0.5
        });
        adIconTitle.y = 15;
        adIconTitle.angle = -20;
        adIconTitle.anchor.set(0.5);
        this.addChild(adIconTitle);
    }

    public get animate(): boolean
    {
        return this._animate;
    }

    public set animate(v: boolean)
    {
        this._animate = v;
        if (!this._animate) this.icon.rotation = 0;
    }

    public updateTransform(): void
    {
        super.updateTransform();
        if (!this._animate) return;
        this.icon.rotation = Math.sin(Ticker.system.lastTime * 0.01) * 0.05;
    }
}
